export { default } from './App'



// WEBPACK FOOTER //
// ./src/App/index.js